import React, { useState, useEffect, useMemo } from 'react';
import { useCart } from '../Contexts/CartContext';

const ProductCard = ({ product }) => {
  const { addToCart } = useCart();
  // State to hold the currently selected options (just the names, e.g., "OLED")
  const [selectedOptions, setSelectedOptions] = useState({});
  
  // When the component loads, set the default option for each variant
  useEffect(() => {
    const defaultOptions = {};
    if (product.options) {
      Object.keys(product.options).forEach(key => {
        // Default to the name of the first option
        defaultOptions[key] = product.options[key][0].name;
      });
    }
    setSelectedOptions(defaultOptions);
  }, [product]);

  // Memoize the price calculation. This will re-run only when options change.
  const currentPrice = useMemo(() => {
    let finalPrice = product.basePrice;
    if (product.options) {
      Object.keys(selectedOptions).forEach(optionName => {
        const selectedValue = selectedOptions[optionName];
        const optionData = product.options[optionName].find(opt => opt.name === selectedValue);
        if (optionData) {
          finalPrice += optionData.priceModifier;
        }
      });
    }
    return finalPrice;
  }, [selectedOptions, product]);

  const handleOptionChange = (optionName, value) => {
    setSelectedOptions(prev => ({ ...prev, [optionName]: value }));
  };

  const handleAddToCart = () => {
    // Pass the product, the selected options, AND the final calculated price to the cart
    addToCart(product, selectedOptions, currentPrice);
  };
  
  return (
    <div className="product-card">
      <div className="product-card-image-container">
        <img src={product.imageUrl} alt={product.name} className="product-card-image" />
        <div className="product-card-overlay">
           <button onClick={handleAddToCart} className="add-to-cart-button">
             Add to Cart
           </button>
        </div>
      </div>
      <div className="product-card-content">
        <h3 className="product-card-name">{product.name}</h3>
        <p className="product-card-description">{product.description}</p>
        
        {product.options && (
          <div className="product-options">
            {Object.entries(product.options).map(([name, values]) => (
              <div key={name} className="option-group">
                <label htmlFor={`${product.id}-${name}`}>{name}</label>
                <select 
                  id={`${product.id}-${name}`}
                  value={selectedOptions[name] || ''}
                  onChange={(e) => handleOptionChange(name, e.target.value)}
                >
                  {values.map(option => <option key={option.name} value={option.name}>{option.name}</option>)}
                </select>
              </div>
            ))}
          </div>
        )}

        {/* Display the dynamically calculated price */}
        <div className="product-card-price">${currentPrice.toFixed(2)}</div>
      </div>
    </div>
  );
};

export default ProductCard;